<template>
    <div class="page products-page px-md-8"> <!-- white fill-height -->
        <transition name="fade-transition">
            <v-container v-if="productData" class="py-3 py-lg-8 px-0" :style="pcOnly ? 'max-width: 1100px!important' : 'max-width: 100%;'">
                <div class="d-flex flex-column flex-lg-row">
                    <div class="flex-grow-1 me-lg-12 overflow-hidden px-2 px-lg-1">
                        <div class="d-flex justify-center justify-lg-space-between flex-column flex-lg-row mb-4 mb-lg-6">
                            <div class="me-lg-8 px-4 px-lg-0">
                                <v-img :src="productData.main_image_url" height="190" :width="pcOnly ? 200 : 'auto'" style="border-radius: 8px" class="bordered">
                                    <div style="position: absolute; top: 5px; right: 5px;">
                                        <v-chip v-if="productData.featured" dark color="orange darken-1" small style="height: 22px">
                                            <v-icon left size="16">mdi-star-circle-outline</v-icon>
                                            <span>منتج مميز</span>
                                        </v-chip>
                                    </div>
                                </v-img>
                            </div>
                            <div class="flex-grow-1 py-6 px-4 pa-lg-0">
                                <div class="mb-1">
                                    <v-btn small text color="muted" class="px-1" :to="{name: 'products'}" exact>
                                        <v-icon size="20" left class="me-1">mdi-chevron-right</v-icon>
                                        <span>العودة للخلف</span>
                                    </v-btn>
                                </div>
                                <h2 class="strong-text--text font-weight-medium default-font">{{productData.name}}</h2>
                                <div class="mt-3">
                                    <v-chip v-for="category in productData.categories" :key="category.id" small label class="px-2 me-2" style="height: 20px; background-color: rgba(0,0,0, .04)!important">
                                        <v-icon color="text">mdi-view-grid</v-icon>
                                        <span class="ms-1">{{category.name}}</span>
                                    </v-chip>
                                </div>
                                <div class="mt-3 d-flex align-center" style="line-height: 1!important">
                                    <v-rating :value="productData.overall_rating || 0" color="amber" dense half-increments empty-icon="mdi-star-outline" background-color="grey lighten-1" readonly size="18" ></v-rating>
                                    <span class="details-text ms-1" :class="{'amber--text text--darken-3': productData.overall_rating === 5, 'text--text': productData.overall_rating < 5}">({{productData.overall_rating || 0}})</span>
                                </div>
                                <!-- <v-divider class="my-3"></v-divider> -->
                                <div class="mt-5 w-100 d-flex">
                                    <v-btn v-if="!capRunning" as="a" target="_blank" :color="pcOnly ? 'white' : 'primary'" v-ripple="phoneOnly" :href="productData.product_url">
                                        <v-icon left>mdi-open-in-new</v-icon>
                                        <span>فتح صفحة المنتج</span>
                                    </v-btn>
                                    <v-btn v-else :color="pcOnly ? 'white' : 'primary'" v-ripple="phoneOnly" @click="openUrl(productData.product_url)">
                                        <v-icon left>mdi-open-in-new</v-icon>
                                        <span>فتح صفحة المنتج</span>
                                    </v-btn>

                                    <div v-if="phoneOnly" class="ms-3">
                                        <v-menu v-if="actions && actions.length" bottom :offset-y="true" transition="slide-y-transition">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="white" v-bind="attrs" v-on="on">
                                                    <v-icon left class="me-1">mdi-dots-vertical</v-icon>
                                                    <span>إجراءات</span>
                                                </v-btn>
                                            </template>
                                            <v-list dense min-width="250">
                                                <v-list-item v-for="action in actions" :key="action.name" @click="action.onclick" :disabled="action.disabled" v-ripple="{class: 'ripple--color'}">
                                                    <v-list-item-icon class="me-4">
                                                        <v-icon size="22" :color="action.color" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.icon}}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="medium-text mb-0" style="line-height: 1.6!important">{{action.title}}</v-list-item-title>
                                                        <v-list-item-subtitle class="details-text" style="line-height: 1.5!important" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.subtitle}}</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <v-card flat class="bordered mb-4 mb-lg-6">
                            <v-card-title class="medium-title mb-1">
                                <v-icon color="strong-text" size="22" class="me-2">mdi-view-split-horizontal</v-icon>
                                <span>خيارات المنتج</span>
                            </v-card-title>
                            <v-card-subtitle class="details-text muted--text">يمكنك إضافة خيارات متعددة للمنتج يختار من بينها المشتري</v-card-subtitle>
                            <v-card-text :class="{'px-0': phoneOnly}">
                                <v-list class="transparent">
                                    <template v-for="variant in productData.variants">
                                        <product-variant-item :product="productData" :variant="variant" :key="variant.id" @sync="sync" />
                                        <v-divider inset :key="'divider-' + variant.id"     />
                                    </template>

                                    <v-list-item dense class="" @click="newVariantDialog=true" v-ripple="{class: 'ripple--color'}">
                                        <v-list-item-icon class="me-4 me-lg-6">
                                            <v-icon color="primary">mdi-plus-box-multiple-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title class="strong-text--text">إضافة خيار شراء جديد</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>

                        <v-card flat class="bordered mb-4 mb-lg-6" style="max-width 100%; overflow: hidden">
                            <v-card-title>صور المنتج</v-card-title>
                            <v-card-subtitle>يمكنك إضافة صور متعددة لكل خيار من خيارات المنتج</v-card-subtitle>
                            <v-card-text>
                                <v-overlay v-if="photosUploading" absolute color="#fff" opacity="0.75"></v-overlay>
                                <v-select v-model="selectedVariant" outlined dense auto-select-first :items="variantsSelectItems" hide-details></v-select>

                                <div v-if="photosSelectedVariant.photos && photosSelectedVariant.photos.length">
                                    <div class="d-flex mt-6 flex-wrap w-100 bordered pa-1">
                                        <div v-for="(photo, i) in photosSelectedVariant.photos" :key="i" class="ma-1">
                                            <v-img cover center :src="photo.url" width="114" height="105" style="border-radius: 4px" class="variant-photo bordered">
                                                <div class="photo-actions" style="position: absolute; top: 5px; left: 5px;">
                                                    <v-btn icon small color="red" @click="openDeletePhotoDialog(photo)">
                                                        <!-- <v-icon size="20">mdi-dots-vertical</v-icon> -->
                                                        <v-icon size="19">mdi-delete</v-icon>
                                                    </v-btn>
                                                </div>
                                            </v-img>
                                        </div>
                                        <div>
                                            <transition name="fade-transition" appear>
                                                <v-img width="114" height="105" class="add-image d-flex align-center ma-1" @click="openImagesUpload">
                                                    <div class="text-center">
                                                        <v-icon color="grey" class="mx-auto">mdi-image-plus</v-icon>
                                                    </div>
                                                </v-img>
                                            </transition>
                                        </div>
                                    </div>
                                    <!-- <v-btn block color="primary" text @click="openImagesUpload">
                                        <v-icon left>mdi-image-plus</v-icon>
                                        <span>إضافة صور جديدة</span>
                                    </v-btn> -->
                                </div>
                                <div v-else class="mt-3">
                                    <v-alert type="info" text color="grey">
                                        <span class="text--text details-text">لم يتم إضافة صور لهذا المنتج!</span>
                                        <v-btn small class="ms-4" color="primary" outlined @click="openImagesUpload">
                                            <v-icon left>mdi-image-plus</v-icon>
                                            <span>أضف اﻵن</span>
                                        </v-btn>
                                    </v-alert>
                                </div>

                                <input ref="imageInput" type="file" @change="handleImagesUpload" accept="image/*" hidden multiple />
                            </v-card-text>
                        </v-card>

                        <v-card flat class="bordered mb-4 mb-lg-6">
                            <v-card-title>وصف المنتج</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-text>
                                <v-textarea no-resize rows="5" outlined readonly :value="description" class="description-textarea e-link-nested" placeholder="أدخل وصف للمنتج..." hide-details @click="openDescriptionDialog"></v-textarea>
                            </v-card-text>
                        </v-card>

                        <v-card flat class="bordered mb-4 mb-lg-6">
                            <v-card-title class="d-flex justify-space-between">
                                <div>منتجات ذات صلة</div>
                                <div>
                                    <v-btn color="primary" depressed small @click="openAddRelatedProductDialog()">إضافة منتج</v-btn>
                                </div>
                            </v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-text>
                                <v-list>
                                    <v-list-item v-for="product in productData.related_products" :key="product.id">
                                        <v-list-item-avatar tile size="36">
                                            <v-img :src="product.main_image_url"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{product.name}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-btn icon color="error" @click="removeRelatedProduct = product; removeRelatedProductDialog = true;">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>

                        <!-- <v-card class="card-shadow mb-4 mb-lg-6">
                            <v-card-title>صور المنتج</v-card-title>
                            <v-card-subtitle>يمكنك إضافة صور متعددة لكل خيار من خيارات المنتج</v-card-subtitle>
                            <v-card-text>

                            </v-card-text>
                        </v-card> -->

                        <!-- <div>
                            <crud-table :actions="actions" show-search search-placeholder="ابحث في المنتجات" server-pagination :page-count="productsMeta.last_page" :current-page="productsMeta.current_page" :total="productsMeta.total" :per-page="productsMeta.per_page" create-button-text="إضافة منتج" title="المنتجات" :items="productsItems" :headers="headers" @load="loadMore" @search="searchHandler" @reset="reset" @create="createDialog = true" @delete="openDeleteDialog" @edit="openEditDialog" />
                        </div> -->
                    </div>
                    <div>

                        <v-card class="transparent mb-3" flat width="275">
                            <v-card-title style="font-size: 1rem" class="py-2">إجراءات</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="px-0 py-1">
                                <v-list class="pa-0 transparent">
                                    <v-list-item v-for="action in actions" :key="action.name" @click="action.onclick" :disabled="action.disabled" v-ripple="{class: 'ripple--color'}">
                                        <v-list-item-icon class="me-4">
                                            <v-icon size="22" :color="action.color" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.icon}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="medium-text mb-0" style="line-height: 1.6!important">{{action.title}}</v-list-item-title>
                                            <v-list-item-subtitle class="details-text" style="line-height: 1.5!important" :style="action.disabled ? 'opacity: 0.5' : ''">{{action.subtitle}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>

                <action-dialog v-model="newVariantDialog" scrollable max-width="420" vuex-action="newProductVariant" success-msg="تم إضافة خيار الشراء بنجاح" title="إضافة خيار شراء جديد" subtitle="سيختار المشتري واحد من خيارات المنتج عند الشراء" button-text="إضافة" :data="{...newVariant, product_id: id}" @reset="resetNewVariantForm" @sync="sync">
                    <div class="pt-1">
                        <v-text-field v-model="newVariant.name" autofocus label="اسم الخيار" placeholder="أدخل اسم لخيار الشراء" hide-details prepend-inner-icon="mdi-view-split-horizontal" class="mb-5"></v-text-field>


                        <v-text-field v-model="newVariant.price" type="number" label="السعر" placeholder="أدخل السعر" min="0" hide-details suffix="" prepend-inner-icon="mdi-cash" class="mb-5"></v-text-field>
                        <template v-if="productData.track_stock">
                            <v-text-field v-model="newVariant.stock" type="number" label="الكمية المتوفرة" placeholder="أدخل الكمية المتوفرة من مخزون المنتج" prepend-inner-icon="mdi-package-variant" min="0" hide-details suffix="" class="mb-5"></v-text-field>
                        </template>
                    </div>
                </action-dialog>

                <action-dialog v-model="editDialog" scrollable max-width="420" vuex-action="editProduct" success-msg="تم حفظ التغييرات بنجاح" title="تعديل المنتج" subtitle="سيتم تنفيذ التغييرات لحظياً" button-text="تعديل" :data="{id: id, data: editedItem}" @reset="resetEditForm" @sync="sync">
                    <div class="pt-1">
                        <v-text-field v-model="editedItem.name" label="اسم المنتج" placeholder="أدخل اسم المنتج" hide-details class="mb-5"></v-text-field>
                        <!-- <v-select v-model="editedItem.hidden" label="ظهور المنتج" :items="[{text:'الظهور مفعل', value: false}, {text: 'مخفي من المتجر', value: true}]" placeholder="اختر ظهور المنتج" hide-details class="mb-5"></v-select> -->

                        <v-checkbox v-model="editedItem.track_stock" label="تفعيل إدارة المخزون" color="primary" class="mb-3" hide-details></v-checkbox>
                        <v-checkbox v-model="editedItem.featured" label="تحديد كمنتج مميز" color="orange darken-1" class="mb-3" hide-details></v-checkbox>
                    </div>
                </action-dialog>

                <action-dialog v-model="addRelatedProductDialog" scrollable max-width="325" vuex-action="addToRelatedProducts" success-msg="تم حفظ التغييرات بنجاح" title="إضافة منتج ذات صلة" button-text="حفظ" :data="{id: id, data: {product_id: addRelatedProductId}}" @sync="sync" @reset="addRelatedProductId = null;">
                    <div class="pt-1">
                        <v-autocomplete v-model="addRelatedProductId" :disabled="loadingList" :loading="loadingList" :items="productsListComputed" label="اختر المنتج" placeholder="اختر المنتج" hide-details></v-autocomplete>
                    </div>
                </action-dialog>

                <action-dialog v-model="removeRelatedProductDialog" vuex-action="removeFromRelatedProducts" :title="`إزالة من المنتجات ذات صلة`" :data="{id: id, data: {product_id: removeRelatedProduct ? removeRelatedProduct.id : null}}" button-text="تأكيد" button-color="error" @sync="sync" @reset="removeRelatedProduct = null;">
                    هل أنت متأكد من إزالة المنتج من المنتجات ذات صلة؟
                </action-dialog>

                <action-dialog v-model="descriptionDialog" scrollable max-width="550" vuex-action="editProduct" success-msg="تم حفظ التغييرات بنجاح" title="تعديل وصف المنتج" subtitle="وصف مفصل للمنتج ليعرف المشتري تفاصيل أكثر عن منتجك أثناء تصفح صفحة للمنتج" button-text="حفظ" :data="{id: id, data: {description: newDescription}}" @sync="sync">
                    <div class="pt-1">
                        <v-textarea no-resize rows="5" outlined v-model="newDescription" class="description-textarea" placeholder="أدخل وصف للمنتج..." hide-details></v-textarea>
                    </div>
                </action-dialog>

                <action-dialog v-model="hiddenDialog" scrollable max-width="325" vuex-action="editProduct" success-msg="تم حفظ التغييرات بنجاح" title="تعديل ظهور المنتج" button-text="حفظ" :data="{id: id, data: {hidden: newHidden}}" @sync="sync">
                    <div class="pt-1">
                        <v-select v-model="newHidden" label="ظهور المنتج" :items="[{text:'الظهور مفعل', value: false}, {text: 'مخفي من المتجر', value: true}]" placeholder="اختر ظهور المنتج" hide-details></v-select>
                    </div>
                </action-dialog>

                <action-dialog v-model="deletePhotoDialog" vuex-action="deleteProductPhoto" :title="`حذف الصورة`" :data="{id: deletePhoto ? deletePhoto.id : null}" button-text="تأكيد الحذف" button-color="error" @sync="sync" @reset="deletePhoto = null;">
                    هل أنت متأكد من حذف الصورة؟
                </action-dialog>

                <action-dialog v-model="deleteDialog" vuex-action="deleteProduct" :title="`حذف المنتج #${id}`" :data="{id: deleteItem ? deleteItem.id : null}" button-text="تأكيد الحذف" button-color="error">
                    هل أنت متأكد من حذف المنتج <span class="strong-text--text">"{{productData.name}}"</span> ؟
                </action-dialog>
            </v-container>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CrudTable from '@/components/default/crud-table'
import ProductVariantItem from '@/components/custom/product-variant-item'

export default {
    name: "Products",
    components: {
        CrudTable,
        ProductVariantItem
    },
    data(){
        return {
            loading: false,   
            photosUploading: false,
            productData: null,

            hiddenDialog: false,
            newHidden: '',

            descriptionDialog: false,
            newDescription: '',

            selectedVariant: '',

            deletePhotoDialog: false,
            deletePhoto: null,

            addRelatedProductDialog: false,
            addRelatedProductId: null,
            loadingList: false,
            productsList: null,

            removeRelatedProductDialog: false,
            removeRelatedProduct: null,

            newVariantDialog: false,
            newVariant: {
                name: '',
                stock: '',
                price: '',
            },

            editDialog: false,
            editedItem: {
                name: '',
                categories: [],
                track_stock: false,
                // hidden: false,
                featured: false,
            },

            deleteDialog: false,
            deleteItem: null,

            
        }
    },
    computed: {
        ...GlobalComputed,
        photosSelectedVariant(){
            return this.productData.variants.find(variant=>variant.id === this.selectedVariant);
        },
        id(){
            return this.$route.params.id;
        },
        variantsSelectItems(){
            return this.productData ? this.productData.variants.map(variant=>{
                return {text: variant.name, value: variant.id};
            }) : [];
        },
        actions(){
            return [
                this.hiddenAction,
                {name: 'edit', icon: 'mdi-square-edit-outline', color: 'muted', title: 'تعديل المنتج', subtitle: 'تعديل البيانات الرئيسية للمنتج', onclick: this.openEditDialog},
                {name: 'delete', icon: 'mdi-delete', color: 'error', title: 'حذف المنتج', subtitle: 'سيتم الحذف النهائي للمنتج', onclick: this.openDeleteDialog, disabled: !this.productData.deletable},
            ]
        },
        hiddenAction(){
            if (this.productData.hidden){
                return {name: 'hidden', icon: 'mdi-eye-off', color: 'text', title: 'ظهور المنتج (مختفي)', subtitle: 'لن يظهر المنتج في المتجر الخاص بك', onclick: this.openHiddenDialog};
            }else{
                return {name: 'hidden', icon: 'mdi-eye', color: 'primary', title: 'ظهور المنتج (ظاهر)', subtitle: 'المنتج ظاهر في المتجر الخاص بك', onclick: this.openHiddenDialog};
            }
        },
        description(){
            // return 'هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع الفقرات في الصفحة التي يقرأها. ولذلك يتم استخدام طريقة لوريم إيبسوم لأنها تعطي توزيعاَ طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام "هنا يوجد محتوى نصي، هنا يوجد محتوى نصي" فتجعلها تبدو (أي الأحرف) وكأنها نص مقروء. العديد من برامح النشر المكتبي وبرامح تحرير صفحات الويب تستخدم لوريم إيبسوم بشكل افتراضي كنموذج عن النص، وإذا قمت بإدخال "lorem ipsum" في أي محرك بحث ستظهر العديد من المواقع الحديثة العهد في نتائج البحث. على مدى السنين ظهرت نسخ جديدة ومختلفة من نص لوريم إيبسوم، أحياناً عن طريق الصدفة، وأحياناً عن عمد كإدخال بعض العبارات الفكاهية إليها.';
            return this.productData.description;
        },
        productsListComputed(){
            if (this.productsList){
                const related = this.productData.related_products ? this.productData.related_products.map(product=>product.id) : [];
                return this.productsList.filter(item=>{return !related.includes(item.id)}).map(item=>{
                    return {text: item.name, value: item.id};
                });
            }
            return [];
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        photosUploading(loading){
            this.setLinearLoading(loading);
        },
        id(){
            this.loadProductData();
        }
    },
    methods: {
        ...GlobalMethods,
        openAddRelatedProductDialog(){
            this.addRelatedProductDialog = true;

            if (!this.loadingList && !this.productsList){
                this.loadingList = true;
                window.axios.get(`/products/list`).then(response=>{
                    this.loadingList = false;
                    this.productsList = response.data;
                }).catch(e=>{
                    this.loadingList = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل بيانات المنتجات', 'error');
                })
            }

        },
        openUrl(url){
            window.open(url, '_system');
        },
        loadProductData(){
            if (!this.loading){
                this.loading = true;
                window.axios.get(`/products/${this.id}`).then(response=>{
                    this.loading = false;
                    this.productData = response.data.data;
                    if (this.productData.variants && this.productData.variants[0]){
                        this.selectedVariant = this.productData.variants[0].id;
                    }
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل بيانات المنتج', 'error');
                })
            }
        },
        openHiddenDialog(){
            this.newHidden = this.productData.hidden;
            this.hiddenDialog = true;
        },
        openDeletePhotoDialog(photo){
            this.deletePhoto = photo;
            this.deletePhotoDialog = true;
        },
        openDescriptionDialog(){
            this.newDescription = this.productData.description;
            this.descriptionDialog = true;
        },
        openEditDialog(){
            for(let key in this.editedItem){
                if (key === 'categories'){
                    this.editedItem.categories = this.productData.categories.map(c=>c.id);
                }else{
                    this.editedItem[key] = this.productData[key];
                }
            }
            // Object.assign(this.editedItem, item);
            this.editDialog = true;
        },
        resetEditForm(){
            this.editedItem = {
                id: '',
                name: '',
                categories: [],
                track_stock: false,
                hidden: false,
                featured: false,
            };
        },
        resetNewVariantForm(){
            this.newVariant = {
                name: '',
                stock: '',
                price: '',
            };
        },
        openDeleteDialog(item){
            this.deleteDialog = true;
            this.deleteItem = item;
        },
        sync(data){
            Object.assign(this.productData, data);
        },

        openImagesUpload(){
            this.$refs.imageInput.click();
        },
        handleImagesUpload(event){
            let files = event.target.files;
            if (files && files.length){
                this.uploadNewImages(files);
            }
        },
        uploadNewImages(files){
            let formData = new FormData(),
                images = [...files];
            images.forEach(image => {
                formData.append('images[]', image);
            });
            if (!this.photosUploading){
                this.photosUploading = true;
                this.$store.dispatch('uploadProductPhotos', {id: this.selectedVariant, data: formData, headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
                    
                    this.showMsg('تمت إضافة الصور بنجاح', 'success');
                    this.photosUploading = false;
                    this.sync(response.data.data);
                }).catch(()=>{
                    this.photosUploading = false;
                    this.showMsg('حدثت مشكلة أثناء الرفع', 'error');
                });
            }
        },
    },
    mounted(){
        this.loadProductData();
    }
};
</script>

<style lang="scss" scoped>
.variant-photo{
    .photo-actions{
        opacity: 0;
        transition: 0.2s ease all;
    }
    &:hover{
        .photo-actions{
            opacity: 1;
        }
    }
}
.add-image{
    border-radius: 4px;
    border: 2px dashed rgba(0,0,0, .1)!important;
    cursor: pointer;
    transition: 80ms ease-out all;

    &:hover{
        border-color: rgba(0,0,0, .3)!important;
    }
    &:active{
        transform: scale(0.97);
    }
}
</style>
<style lang="scss">
.description-textarea{
    textarea{
        font-size: 13px;
        line-height: 1.55rem!important;
    }
    &:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot{
        fieldset{
            color: rgba(0, 0, 0, 0.04)!important;
        }

        &:hover{
            fieldset{
                color: rgba(0, 0, 0, 0.2)!important;
            }
        }
    }
}
</style>
